import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { appRoutes } from './routes.constant';
import { AuthGuard } from '../common/auth/auth.guard';
import { DigitalHubComponent } from '../features/digital-hub/digital-hub.component';

export const routesArr: Routes = [
  { path: '', redirectTo: appRoutes.DIGITAL_HUB,  pathMatch: 'full' },
  {
    path: 'txn',
    loadChildren: () => import('../features/transactions/transactions.module').then(m => m.TransactionsModule)
  },
  {
    path: 'sec-master',
    loadChildren: () => import('../features/sec-master/sec-master.module').then(m => m.SecMasterModule)
  },
  { 
    path: 'users',
    loadChildren: () => import('../features/users/users.module').then(m => m.UsersModule)
  },
  { 
    path: 'create-client',
    loadChildren: () => import('../features/create-client/create-client.module').then(m => m.CreateClientModule)
  },
  { path: appRoutes.DIGITAL_HUB, component: DigitalHubComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [ RouterModule.forRoot(routesArr, {useHash: true, onSameUrlNavigation: 'reload'}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}